import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const BarnCIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M4.88571 17.2286H0.771429V7.62857L4.88571 4.2M4.88571 17.2286V10.6208M4.88571 17.2286H13.1143M13.1143 17.2286H17.2286V7.62857L13.1143 4.2M13.1143 17.2286V10.6208M4.88571 10.6208H9M4.88571 10.6208V4.2M13.1143 10.6208H9M13.1143 10.6208V4.2M9 0.771429V10.6208M9 0.771429L4.88571 4.2M9 0.771429L13.1143 4.2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

BarnCIcon.displayName = 'BarnCIcon';
